import { useState, useRef, useEffect, useCallback } from "react";
import { getCalendarAgenda, getCalendars, createCalendar } from "../../services/api";

export const useContentCalendar = (subscriptionId, range) => {
  const [data, setData] = useState({ calendars: [], posts: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const version = useRef(0);
  const reload = useCallback(async () => {
    const request = ++version.current;
    if (!subscriptionId) { setData({ calendars: [], posts: [] }); setLoading(false); return; }
    setLoading(true); setError("");
    try {
      const result = await getCalendarAgenda({ subscription_id: subscriptionId, start: range.start, end: range.end });
      if (request === version.current) setData(result.data);
    } catch (err) {
      if (request === version.current) { setData({ calendars: [], posts: [] }); setError(err.response?.status === 403 ? "Accès au calendrier retiré par l’administrateur." : "Impossible de charger les publications."); }
    } finally { if (request === version.current) setLoading(false); }
  }, [subscriptionId, range.start, range.end]);
  useEffect(() => { reload(); return () => { version.current += 1; }; }, [reload]);
  const ensureCalendar = async period => {
    const existing = data.calendars.find(cal => cal.period === period && cal.subscription_id === subscriptionId);
    if (existing) return existing;
    const { data: found } = await getCalendars({ subscription_id: subscriptionId, period });
    if (found.length) return found[0];
    try { return (await createCalendar({ subscription_id: subscriptionId, period })).data; }
    catch (err) {
      if (err.response?.status !== 400) throw err;
      const { data: retry } = await getCalendars({ subscription_id: subscriptionId, period });
      if (retry.length) return retry[0];
      throw err;
    }
  };
  return { ...data, loading, error, reload, ensureCalendar };
};